// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_TREATMENT_CATEGORY,
	SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS,
	SETTING_UPDATE_TREATMENT_CATEGORY,
	SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS,
	SETTING_LOAD_TREATMENT_CATEGORY,
	SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS,
	SETTING_DELETE_TREATMENT_CATEGORY,
	SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_TREATMENT,
	SETTING_LOAD_TREATMENT_SUCCESS,
	SETTING_CREATE_TREATMENT,
	SETTING_CREATE_TREATMENT_SUCCESS,
	SETTING_UPDATE_TREATMENT,
	SETTING_UPDATE_TREATMENT_SUCCESS,
	SETTING_DELETE_TREATMENT,
	SETTING_DELETE_TREATMENT_SUCCESS,
	SETTING_UPDATE_TREATMENT_STATUS,
	SETTING_UPDATE_TREATMENT_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	treatmentLoading: false,
	treatmentCategoryLoading: false,
	treatmentCategory: [],
	optionTreatmentCategory: [],
	treatment: [],
	optionTreatment: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_TREATMENT_CATEGORY:
			return { ...state, treatmentCategoryLoading: true, }
		case SETTING_LOAD_TREATMENT_CATEGORY_SUCCESS:
			return {
				...state,
				treatmentCategoryLoading: false,
				treatmentCategory: action.payload,
				optionTreatmentCategory: action.payloadlist
			}
		case SETTING_CREATE_TREATMENT_CATEGORY:
			return { ...state, treatmentCategoryLoading: true }
		case SETTING_CREATE_TREATMENT_CATEGORY_SUCCESS:
			return { ...state, treatmentCategoryLoading: false }
		case SETTING_UPDATE_TREATMENT_CATEGORY:
			return { ...state, treatmentCategoryLoading: true }
		case SETTING_UPDATE_TREATMENT_CATEGORY_SUCCESS:
			return { ...state, treatmentCategoryLoading: false }
		case SETTING_DELETE_TREATMENT_CATEGORY:
			return { ...state, treatmentCategoryLoading: true }
		case SETTING_DELETE_TREATMENT_CATEGORY_SUCCESS:
			return { ...state, treatmentCategoryLoading: false }
		case SETTING_LOAD_TREATMENT:
			return { ...state, treatmentLoading: true, }
		case SETTING_LOAD_TREATMENT_SUCCESS:
			return {
				...state,
				treatmentLoading: false,
				treatment: action.payload,
				optionTreatment: action.payloadlist
			}
		case SETTING_CREATE_TREATMENT:
			return { ...state, treatmentLoading: true }
		case SETTING_CREATE_TREATMENT_SUCCESS:
			return { ...state, treatmentLoading: false }
		case SETTING_UPDATE_TREATMENT:
			return { ...state, treatmentLoading: true }
		case SETTING_UPDATE_TREATMENT_SUCCESS:
			return { ...state, treatmentLoading: false }
		case SETTING_DELETE_TREATMENT:
			return { ...state, treatmentLoading: true }
		case SETTING_DELETE_TREATMENT_SUCCESS:
			return { ...state, treatmentLoading: false }
		case SETTING_UPDATE_TREATMENT_STATUS:
			return { ...state, treatmentLoading: true }
		case SETTING_UPDATE_TREATMENT_STATUS_SUCCESS:
			return { ...state, treatmentLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				treatmentLoading: false,
				treatmentCategoryLoading: false,
				treatmentCategory: [],
				optionTreatmentCategory: [],
				treatment: [],
				optionTreatment: [],
			};

		default: return { ...state };
	}
}